import React from "react";
import {
  Filter,
  List,
  Datagrid,
  TextField,
  EditButton,
  DateField,
  ReferenceInput,
  ReferenceField,
  SelectInput,
  Responsive,
  SimpleList,
  NumberInput,
  NumberField,
  DateInput
} from "react-admin";

import { RemitosEditComponent } from "../components/Remitos/RemitosEditComponent";
import { RemitosCreateComponent } from "../components/Remitos/RemitosCreateComponent";

export const RemitosFilter = props => {
  return (
    <Filter {...props}>
      <DateInput label="Fecha" source="fecha" />
      <ReferenceInput
        reference="operarios"
        source="operario"
        sort={{ field: "nombre", order: "ASC" }}
      >
        <SelectInput optionText="nombre" optionValue="_id" />
      </ReferenceInput>
      <NumberInput label="Número" source="numero" />
      <ReferenceInput reference="entidades" source="vendedor">
        <SelectInput optionText="nombre" optionValue="_id" />
      </ReferenceInput>
      <ReferenceInput reference="entidades" source="comprador">
        <SelectInput optionText="nombre" optionValue="_id" />
      </ReferenceInput>
    </Filter>
  );
};

export const RemitosList = props => (
  <List
    {...props}
    bulkActions={false}
    filters={<RemitosFilter />}
    exporter={false}
    sort={{ field: "fecha", order: "DESC" }}
  >
    <Responsive
      small={
        <SimpleList
          primaryText={record => record.numero}
          secondaryText={record => new Date(record.fecha).toLocaleDateString()}
        />
      }
      medium={
        <Datagrid>
          <DateField source="fecha" />
          <NumberField source="numero" />
          <ReferenceField
            label="vendedor"
            reference="entidades"
            source="vendedor"
          >
            <TextField source="nombre" />
          </ReferenceField>
          <ReferenceField
            label="comprador"
            reference="entidades"
            source="comprador"
          >
            <TextField source="nombre" />
          </ReferenceField>
          <DateField label="ultima modificacion" source="updatedAt" />
          <EditButton />
        </Datagrid>
      }
    />
  </List>
);

export const RemitosCreate = props => <RemitosCreateComponent {...props} />;

export const RemitosEdit = props => <RemitosEditComponent {...props} />;



// WEBPACK FOOTER //
// ./src/services/remitos.js